import Grid from '@mui/material/Grid';

import { FormInput } from '../../../components/hook-form/form-input.component';
import { FormCheckbox } from '../../../components/hook-form/form-checkbox.component';
import FormDateField from '../../query-builder/hooks-form-querybuilder/form-date.field.component';
import { useFormContext } from 'react-hook-form';
import { holidayManagementApiKeyStore } from '../../../api/masters/holiday-management-api-key-store';
import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';
import { useEffect, useState } from 'react';
import { useAuthorize } from '../../../hooks/use-authorize';
import { UserPermissionName } from '../../../models/user-permission-name';

interface HolidayForm {
  editItem?: Partial<any> | undefined;
}
export const HolidayForm = ({ editItem }: HolidayForm) => {

  const { setValue, getValues } = useFormContext();

  // const [holidayDates, setHolidayDates] = useState<any[]>([]);
  // const { isLoading, data: holidayData } = useLoadData<ApiResponse<any[]>>(holidayManagementApiKeyStore.getHolidays());
  // useEffect(() => {
  //   if (holidayData) {
  //     const holidayID = getValues('holidayID') ?? 0;
  //     const datesResult = holidayData?.data
  //       ?.filter(item => item.holidayID !== holidayID)
  //       ?.map(item => item.holidayDate);
  //     setHolidayDates(datesResult);
  //   }
  // }, [holidayData])

  const handleDateChange = (date: any) => {
    if (date) {
      const year = new Date(date).getFullYear();
      setValue('year', year);
    }
    else
      setValue('year', null);
  }

  // const isWeekendHolidaySchedulingOverridePermission = useAuthorize([UserPermissionName?.WEEKEND_HOLIDAY_SCHEDULING_OVERRIDE]);

  return (
    <Grid container spacing={2}>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput label="Holiday Name" name="holidayName" />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormDateField
          label="Holiday Date"
          name="holidayDate"
          onChange={handleDateChange}
          // restrictDateSelection={isWeekendHolidaySchedulingOverridePermission}
          // holidayDateList={isWeekendHolidaySchedulingOverridePermission ? holidayDates : []}
          // isLoading={isLoading}
          // disabled={isLoading} 
          />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput label="Year" name="year" disabled />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <FormInput label="Description" name="description" maxLength={150} multiline={true} />
      </Grid>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <Grid container direction="row" justifyContent="flex-end" alignItems="flex-start">
          <FormCheckbox label="Active" name="isActive" />
        </Grid>
      </Grid>
    </Grid>
  );
};
